import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import { useEffect } from 'modules/core/hooks/useEffect'

import { ContractFlowType } from 'modules/contracts/components/FlowPage'
import FormWrapper from 'modules/contracts/components/FlowPage/FormWrapper'
import { useContractVersions } from 'modules/contracts/lib/contractVersionsContext'
import { translate } from 'modules/contracts/lib/translate'
import type ContractVersion from 'modules/contracts/store/models/ContractVersion'

import ContractDates from './ContractDates'
import { stepHasErrors } from './validator'

interface Props {
  form: Form
  translations: { [key: string]: string }
  step: number
  type: ContractFlowType
  setIsCurrentStepCompleted: (isCompleted: boolean) => void
  contractVersion?: ContractVersion
}

const Dates = ({
  form,
  translations,
  step,
  type,
  setIsCurrentStepCompleted,
  contractVersion,
}: Props) => {
  const effectiveOnField = form.get('effective_on')
  const startsOnField = form.has('starts_on') ? form.get('starts_on') : undefined
  const contractVersions = useContractVersions()

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    setIsCurrentStepCompleted(
      !stepHasErrors(form, contractVersions, type) && effectiveOnField.hasValue
    )
  }, [effectiveOnField.value, startsOnField?.value])
  /* eslint-enable react-hooks/exhaustive-deps */

  return (
    <Box gap="s32" paddingBottom="s40">
      <FormWrapper>
        <Text size="400" weight="medium" color="grey1000">
          {translate(translations, 'header')}
        </Text>
      </FormWrapper>
      <FormWrapper>
        <ContractDates
          form={form}
          type={type}
          contractVersion={contractVersion}
          translations={translations}
        />
      </FormWrapper>
    </Box>
  )
}

export default observer(Dates)
